import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const documentationSlice = createSlice({
  name: "userDocumentation",
  initialState: {
    display: false,
    defaultTab: undefined as string | undefined
  },
  reducers: {
    display: (state, action: PayloadAction<{ defaultTab?: string }>) => {
      state.display = true;
      state.defaultTab = action.payload?.defaultTab;
    },
    hide: (state) => {
      state.display = false;
      state.defaultTab = undefined;
    }
  }
});

export const { display, hide } = documentationSlice.actions;

export default documentationSlice.reducer;
